import React, { MouseEventHandler } from "react";
import { T } from "services/lang/LanguageService";
import useIsMobile from "hooks/useIsMobile";
import { DashboardLayoutType, IDashboardComponent } from "api/model/dashboard/DashboardComponent";
import DashboardComponent from "../../group-component/GroupComponent";
import { ContextMenuItem } from "../../tab/DashboardTab";

interface HorizontalFlexLayoutProps {
  components: IDashboardComponent[];
  align?: string;
  justify?: string;
  layoutType: DashboardLayoutType;
  groupId: string;
  onContextMenu: MouseEventHandler<HTMLDivElement>;
  setCurrentContextMenuItems: (currentContextMenuItems: ContextMenuItem[]) => void;
}

const HorizontalFlexLayout = ({
  components,
  align,
  justify,
  layoutType,
  groupId,
  onContextMenu,
  setCurrentContextMenuItems,
}: HorizontalFlexLayoutProps) => {
  const isMobile = useIsMobile();

  return (
    <div
      style={{ height: "100%" }}
      className={`w-full flex flex-row flex-wrap align-items-${align?.toLowerCase()} justify-content-${justify?.toLowerCase()}`}
    >
      {components?.length > 0 ? (
        components.map(component => (
          <div
            key={component.id}
            onContextMenu={onContextMenu}
            className={`w-${isMobile || component.type === "SEPARATOR" ? 12 : (component.layout?.HORIZONTAL_FLEX?.width ?? 6)}`}
            style={{
              height:
                component.type === "NOT_SUPPORTED"
                  ? "auto"
                  : component.layout?.HORIZONTAL_FLEX?.height || 550,
            }}
          >
            <DashboardComponent
              groupId={groupId}
              componentId={component.id}
              component={component}
              layoutType={layoutType}
              setCurrentContextMenuItems={setCurrentContextMenuItems}
            />
          </div>
        ))
      ) : (
        <div className="pl-3">{T("error.group-has-no-components")}</div>
      )}
    </div>
  );
};

export default HorizontalFlexLayout;
